module.exports = __webpack_public_path__ + "img/orange-alert.bae49f83.svg";